import { AccessDenied } from '@containers';

export default [
  {
    path: '/access-denied',
    component: AccessDenied,
  },
];
